import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-about-banner',
    templateUrl: './about-banner.component.html',
    styleUrls: ['./about-banner.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AboutBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
